import { lazy } from 'react';

const Login = lazy(() => import('../../../pages/login'));
const PasswordReset = lazy(() => import('../../../pages/password-reset'));
const AcceptInvitation = lazy(() => import('../../../pages/accept-invitation'));

export const PUBLIC_ROUTES = {
  login: {
    path: '/login',
    exact: true,
    additional: {
      component: Login,
      protected: false,
    },
  },
  passwordReset: {
    path: '/password/reset',
    exact: true,
    additional: {
      component: PasswordReset,
      protected: false,
    },
  },
  acceptInvitation: {
    path: '/invite/:token',
    exact: true,
    additional: {
      component: AcceptInvitation,
      protected: false,
    },
  },
}
